/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import LinearProgress from "@mui/material/LinearProgress"; // Import the LinearProgress component
import logo from "../src/assets/logo.webp";
import rotate from "../src/assets/rotate_plate.png";
import lady from "../src/assets/lady1.png";
import "./App.css";
import "animate.css";
import Form from "./Components/form";


function App() {
  const formSteps = [
    "Name",
    "Geburtsdatum",
    "E-Mail",
    "Körpergrösse in cm",
    "Aktuelles Körpergewicht in kg",
    "Welches Zielgewicht in kg möchtest du erreichen, und in wie vielen Wochen planst du, dieses Ziel zu erreichen?",
    "Erzähle uns kurz von dir. Was bringt dich dazu, unsere Unterstützung zu suchen? Bitte erwähne auch, falls du schwanger bist, stillst oder Mühe hast, dein Hungergefühl zu kontrollieren",
    "Meine Ziele",
    "Was ist für dich deine körperliche Problemzone?",
    "Als Kind/Jugendliche*r sah mein Körper so aus",
    "Hast/Hattest du eine Essstörung?",
    "Mein Durchhaltevermögen von 1-10",
    "Mein Gewebe an den Beinen ist",
    "Notiere hier über 3 Tage deine Ernährung mit Zeitangaben (integriere bitte auch einen Tag vom Wochenende)",
    "Wenn ich meine Ernährung betiteln müsste, wäre es am ehesten",
    "Was und wie viel trinkst du über den Tag verteilt?",
    "Hast du Heisshunger? Wenn ja, um welche Zeit und was isst du in diesen Situationen?",
    "Gläser Alkohol pro Woche",
    "Meine Allergien",
    // 'Take-away oder auswärts bestellen pro Woche',
    "Auswärts essen pro Woche (hier zählt auch Bäckerei, Mensa, bei Eltern essen etc. dazu, alles, was du nicht selbst zubereitet hast)",
    "Auf was achtest du bei deiner Ernährung? Was ist dir wichtig?",
    "Wie oft trainierst du pro Woche? Welche Sportart und wie lange?",
    "Wie viele Minuten trainierst du total pro Woche?",
    "Weisst du mit Sicherheit, wie viele Schritte du im Durchschnitt täglich machst?",
    "Wie viele Schritte machst du durchschnittlich am Tag?",
    "Wie viel Me-Time hast du pro Tag?",
    "Dein Ventil bei Stress",
    "Bist du zufrieden im Job?",
    "Als was arbeitest du, wie viel Prozent und wie verteilt?",
    "Wie viele Stunden schläfst du im Durchschnitt pro Nacht?",
    "Wie gut schläfst du allgemein?",
    "Fühlst du dich am Tag oft müde und energielos?",
    "Wie ist deine Verdauung?",
    "Wie regelmässig ist dein Zyklus?",
    "Was machst du für deine Regeneration, wie oft und wie lange?",
    "Wie oft stehst du auf die Waage?",
    "Gibt es Erkrankungen oder Operationen welche für uns von Relevanz sind?",
    "Gibt es Medikamente welche du regelmässig konsumierst?",
    "Was denkst du sind deine Fehlerquellen, dass du dein Ziel noch nicht erreicht hast?",
    "Wie hoch ist dein durchschnittlicher Ruhepuls am Morgen vor dem ersten Aufstehen?",
    "Unter Stress esse ich mehr Süsses/Salziges/Brot?",
    "Je intensiver der Sport, desto lebendiger fühle ich mich?",
    "In stressigen Situationen bleibe ich ruhig?",
    "Ich gehe erst ins Bett, wenn alles erledigt ist?",
    "Ich vergesse über den Tag oft, richtig zu essen, und hole dies am Abend in aller Ruhe nach?",
    "Bitte lade je ein Foto von vorne, hinten, der Seite, deinem Bauch und deinen Oberschenkeln hoch. Achte darauf, dass du auf jedem Foto gut zu erkennen bist und die Körperpartien vollständig sichtbar sind. Die Fotos helfen uns, deinen Fortschritt besser nachzuvollziehen.",
    // 'Mögliche Körpertypen für die Schlussauswertung',
  ];

  const [currentStep, setCurrentStep] = useState(0);

  const [formValues, setFormValues] = useState({
    name: "", // step 0
    dateOfBirth: "", // step 1
    Email: "", // step 2
    bodyhight: "", // step 3
    currentbody: "", // step 4
    targetWeight: "", // step 5 (must be a realistic kg value; validated in isStepValid)
    about: "", // step 6
    mygoals: "", // step 7
    physicalproblem: "", // step 8
    bodylooked: "", // step 9
    eatingdisorder: "", // step 10
    myperseverance: "", // step 11
    tissuelegs: "", // step 12
    dietwithtimestamp: "", // step 13
    labelmydiet: "", // step 14
    youdrink: "", // step 15
    craving: "", // step 16
    glassesalcohol: "", // step 17
    myallergies: "", // step 18
    eatingperweek: "", // step 19
    attentionyourdiet: "", // step 20
    trainperweek: "", // step 21
    traintotal: "", // step 22
    stepseveryday: "", // step 23
    averageperday: "", // step 24
    Schritte: "", // step 25
    MeTime: "", // step 26
    proTag: "", // step 27
    beiStress: "", // step 28
    zufrieden: "", // step 29
    wieverteilt: "", // step 30
    verteilt: "", // step 31
    Schlafdauer: "", // step 32
    Schlafqualität: "", // step 33
    energielos: "", // step 34
    Verdauung: "", // step 35
    Regeneration: "", // step 36
    stehst: "", // step 37
    Erkrankungen: "", // step 38
    heartrate: "", // step 39
    eatmore: "", // step 40
    feelalive: "", // step 41
    stressful: "", // step 42
    everythingisdone: "", // step 43
    eveninginpeace: "", // step 44
    uploadphotos: "", // step 45
    Zyklus: "", // step 47
    eatingdisorderDetails: "", // Optional details for eating disorder
    bmi: "", // bmi (unrelated to steps)
    bmiTarget: "", // bmiTarget (unrelated to steps)
    sliderValues: 10,
    warningMessage: "", // warning message for weight goal validation
    targetWeightValidationError: "", // health notice when underweight user wants to lose weight
    gender: "", // im Schritt "Geburtsdatum" abgefragt; Fragetext wird in handleSubmit gesetzt
  });

  const [showWarning, setShowWarning] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [vissibleAll, setVissibleAll] = useState(true);
  const [Allfruits, setAllfruits] = useState([]);
  const [emailValid, setEmailValid] = useState(false);
  const [fruitesValueFu, setFruitesValueFu] = useState();
  const [countdown, setCountdown] = useState(60);
  const timerRef = useRef(null);
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [showFinalMessage, setShowFinalMessage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentFruitValues, setCurrentFruitValues] = useState({});

  // const [seinhowStep, setShowStep] = useState(0);
  var seinhowStep = 0;

  function isValidEmail(email) {
    // Regex to ensure the email contains '@' and '.'
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function isStepValid() {
    const fieldName = getFieldName(currentStep);

    // Check if the field is not empty
    if (fieldName.startsWith("uploadphotos")) {
      return (
        formValues.uploadphotosFront !== undefined &&
        formValues.uploadphotosFront !== "" &&
        formValues.uploadphotosBack !== undefined &&
        formValues.uploadphotosBack !== "" &&
        formValues.uploadphotosSide !== undefined &&
        formValues.uploadphotosSide !== "" &&
        formValues.uploadphotosStomach !== undefined &&
        formValues.uploadphotosStomach !== "" &&
        formValues.uploadphotosThighs !== undefined &&
        formValues.uploadphotosThighs !== ""
      );
    }
    if (seinhowStep == 2) {
      const email = formValues.Email;
      if (email !== undefined && email !== "" && isValidEmail(email)) {
        setEmailValid(true); // Email is valid
        return true;
      } else {
        setEmailValid(false); // Email is invalid
        return false;
      }
    }
    if (fieldName === "dateOfBirth") {
      return (
        formValues.dateOfBirth !== undefined &&
        formValues.dateOfBirth !== "" &&
        (formValues.gender === "Weiblich" || formValues.gender === "Männlich")
      );
    }
    const fieldValue = formValues[fieldName];

    if (fieldName === "targetWeight") {
      const w = parseFloat(fieldValue);
      return (
        fieldValue !== undefined &&
        fieldValue !== "" &&
        !Number.isNaN(w) &&
        w >= 30 &&
        w <= 300
      );
    }

    return fieldValue !== undefined && fieldValue !== "";
  }

  const calculateFruitValues = (formValues) => {
    // Initialize all possible fruits with 0
    const fruits = [
      "Ananas",
      "Apfel",
      "Avocado",
      "Birne",
      "Brokkoli",
      "Mais",
      "Rüebli",
      "Tomate",
      "Zucchetti",
      "Peperoni",
    ];

    const newFruits = fruits.reduce((acc, fruit) => {
      acc[fruit] = 0;
      return acc;
    }, {});

    // Helper functions
    const isValid = (value) =>
      value !== undefined && value !== null && value !== "";
    const parseNumber = (value) => {
      if (!isValid(value)) return NaN;
      const num = parseFloat(value);
      return isNaN(num) ? NaN : num;
    };
    const addValue = (fruit, value) => {
      newFruits[fruit] = (newFruits[fruit] || 0) + value;
    };

    // BMI calculation
    const bmi = parseNumber(formValues.bmi);
    const underweightFruits = [
      { name: "Rüebli", value: 1.0 },
      { name: "Zucchetti", value: 1.0 },
      { name: "Apfel", value: 0.5 },
    ];

    const normalWeightFruits = [
      { name: "Rüebli", value: 1.0 },
      { name: "Zucchetti", value: 1.0 },
      { name: "Apfel", value: 1.0 },
      { name: "Avocado", value: 1.0 },
      { name: "Birne", value: 1.0 },
      { name: "Mais", value: 1.0 },
    ];

    const overweightFruits = [
      { name: "Avocado", value: 1.0 },
      { name: "Ananas", value: 1.0 },
      { name: "Apfel", value: 1.0 },
      { name: "Birne", value: 1.0 },
      { name: "Tomate", value: 1.0 },
      { name: "Mais", value: 1.0 },
    ];

    // Then:
    if (!isNaN(bmi)) {
      if (bmi < 19) {
        underweightFruits.forEach(({ name, value }) => addValue(name, value));
      } else if (bmi >= 19 && bmi <= 23.9) {
        normalWeightFruits.forEach(({ name, value }) => addValue(name, value));
      } else if (bmi > 23.9) {
        overweightFruits.forEach(({ name, value }) => addValue(name, value));
      }
    }

    // Physical problem zone
    if (isValid(formValues.physicalproblem)) {
      const problemMap = {
        "Bauch": {
          Rüebli: 1.0,
          Zucchetti: 1.0,
          Apfel: 2.0,
          Tomate: 1.0,
          Ananas: 1.5,
          Birne: 1.0,
          Avocado: 2.0,
        },
        "Oberschenkel / Po": {
          Birne: 1.5,
          Ananas: 1.5,
          Avocado: 0.5,
          Tomate: 1.0,
          Rüebli: 0.5,
          Zucchetti: 0.5,
        },
        "Arme": {
          Avocado: 1.0,
          Ananas: 1.0,
          Tomate: 1.0,
          Rüebli: 0.5,
        },
        "Oberschenkel / Po und Bauch": {
          Avocado: 0.5,
          Ananas: 1.0,
          Birne: 0.5,
          Tomate: 1.5,
          Zucchetti: 1.0,
          Rüebli: 0.5,
        },
        "Oberschenkel / Po und Arme": {
          Avocado: 0.5,
          Ananas: 1.5,
          Tomate: 1.0,
          Zucchetti: 1.0,
        },
        "Ganzer Körper": {
          Tomate: 1.5,
          Ananas: 1.0,
          Zucchetti: 0.5,
        },
      };

      const selectedProblem = problemMap[formValues.physicalproblem];
      if (selectedProblem) {
        Object.entries(selectedProblem).forEach(([fruit, value]) =>
          addValue(fruit, value)
        );
      }
    }

    // Childhood body type
    if (isValid(formValues.bodylooked)) {
      const bodyTypeMap = {
        "Dünn / drahtig": {
          Rüebli: 1.0,
          Avocado: 1.0,
          Apfel: 1.0,
          Birne: 0.5,
        },
        "Athletisch / sichtbare Muskulatur": {
          Zucchetti: 1.0,
          Birne: 1.0,
          Mais: 1.5,
          Ananas: 1.0,
          "Peperoni": 1.0,
        },
        "Massiger als der Durchschnitt": {
          Avocado: 1.0,
          Ananas: 1.5,
          Birne: 1.0,
          Apfel: 1.0,
          Tomate: 1.5,
        },
      };

      const selectedBodyType = bodyTypeMap[formValues.bodylooked];
      if (selectedBodyType) {
        Object.entries(selectedBodyType).forEach(([fruit, value]) =>
          addValue(fruit, value)
        );
      }
    }

    // Eating disorder
    if (isValid(formValues.eatingdisorder)) {
      const disorderMap = {
        "Ja, Magersucht ": { Zucchetti: 2.0, Birne: 0.5 },
        "Ja, Bulimie": { Birne: 1.0, Ananas: 1.0, Zucchetti: 1.0 },
        "Ja, Binge eating": {
          Birne: 1.0,
          Ananas: 1.0,
          Zucchetti: 1.0,
          Tomate: 1.0,
          Mais: 1.0,
        },
      };

      const selectedDisorder = disorderMap[formValues.eatingdisorder];
      if (selectedDisorder) {
        Object.entries(selectedDisorder).forEach(([fruit, value]) =>
          addValue(fruit, value)
        );
      }
    }

    // Perseverance
    const perseverance = parseNumber(formValues.myperseverance);
    if (!isNaN(perseverance)) {
      if (perseverance < 6) {
        ["Tomate", "Rüebli", "Avocado"].forEach((f) =>
          addValue(f, 1.0)
        );
        ["Apfel"].forEach((f) =>
          addValue(f, 0.5)
        );
      } else {
        ["Birne", "Zucchetti", "Ananas", "Mais"].forEach((f) =>
          addValue(f, 1.0)
        );
        ["Apfel"].forEach((f) =>
          addValue(f, 0.5)
        );
      }
    }

    // Diet type
    if (isValid(formValues.labelmydiet)) {
      const dietMap = {
        "Vegan ": { Rüebli: 1.0, Zucchetti: 1.0, Birne: 1.0 },
        "vegetarisch ": { Rüebli: 1.0, Birne: 1.0, Zucchetti: 1.0 },
        "Low carb ": { Ananas: 1.0, Birne: 1.0, Zucchetti: 1.0 },
        "intervallfasten": {
          Ananas: 1.0,
          Birne: 1.0,
          Zucchetti: 1.0,
          Apfel: 1.0,
          Tomate: 1.0,
        },
        "High Protein ": {
          Birne: 1.0,
          Ananas: 1.0,
          Zucchetti: 1.0,
          Tomate: 1.0,
        },
      };

      const selectedDiet = dietMap[formValues.labelmydiet];
      if (selectedDiet) {
        Object.entries(selectedDiet).forEach(([fruit, value]) =>
          addValue(fruit, value)
        );
      }
    }

    // Alcohol consumption
    if (isValid(formValues.glassesalcohol)) {
      const alcoholMap = {
        "Ich trinke kein Alkohol": {
          Zucchetti: 1.0,
          Birne: 1.0,
          Mais: 1.0,
        },
        "1-2 Gläser": {
          Avocado: 1.0,
          Rüebli: 1.0,
          Ananas: 1.0,
          Tomate: 1.0,
          Apfel: 1.0,
        },
        "3-4 Gläser": {
          Avocado: 1.0,
          Apfel: 1.0,
          Rüebli: 1.0,
          Tomate: 1.0,
          Ananas: 1.0,
        },
        "5 und mehr Gläser": { Apfel: 1.0, Avocado: 1.0, Tomate: 1.0 },
      };

      const selectedAlcohol = alcoholMap[formValues.glassesalcohol];
      if (selectedAlcohol) {
        Object.entries(selectedAlcohol).forEach(([fruit, value]) =>
          addValue(fruit, value)
        );
      }
    }

    // Exercise
    if (isValid(formValues.traintotal) && Number(formValues.traintotal) > 300) {
      ["Birne", "Ananas", "Mais", "Zucchetti"].forEach((f) => addValue(f, 1.0));
    }

    // Heart rate - Modified to only add to specific fruits
    if (isValid(formValues.heartrate)) {
      const heartrate = Number(formValues.heartrate);
      if (heartrate > 80) {
        ["Tomate", "Apfel", "Rüebli"].forEach((f) => addValue(f, 1.0));
        addValue("Birne", 0.5);
      } else if (heartrate < 60) {
        // Only add to these fruits if not already covered by other conditions
        ["Ananas", "Mais", "Birne", "Brokkoli", "Avocado"].forEach((f) => addValue(f, 1.0));
        ["Zucchetti"].forEach((f) => addValue(f, 0.5));
      }
    }

    // Stress eating
    if (isValid(formValues.eatmore)) {
      if (formValues.eatmore === "ja") {
        ["Avocado", "Birne", "Ananas", "Tomate", "Zucchetti", "Apfel"].forEach(
          (f) => addValue(f, 1.0)
        );
        ["Birne"].forEach(
          (f) => addValue(f, 0.5)
        );
      } else if (formValues.eatmore === "Nein ich esse weniger") {
        addValue("Rüebli", 1.0);
        addValue("Birne", 0.5);
        addValue("Mais", 0.5);
        addValue("Zucchetti", 1.0);
        addValue("Apfel", 0.5);
      }
    }

    // Exercise intensity
    if (isValid(formValues.feelalive)) {
      if (formValues.feelalive === "ja") {
        ["Ananas", "Birne", "Zucchetti", "Mais"].forEach((f) =>
          addValue(f, 1.0)
        );
      } else if (formValues.feelalive === "Nein") {
        ["Avocado", "Apfel", "Rüebli", "Tomate"].forEach((f) =>
          addValue(f, 1.0)
        );
      }
    }

    // Stress management
    if (isValid(formValues.stressful)) {
      if (formValues.stressful === "ja") {
        ["Ananas", "Birne", "Mais", "Zucchetti"].forEach((f) =>
          addValue(f, 1.0)
        );
        ["Avocado"].forEach((f) =>
          addValue(f, 0.5)
        );
      } else if (formValues.stressful === "Nein") {
        ["Rüebli", "Birne", "Tomate", "Apfel", "Zucchetti"].forEach((f) =>
          addValue(f, 1.0)
        );
      }
    }

    // Work habits
    if (isValid(formValues.everythingisdone)) {
      if (formValues.everythingisdone === "ja") {
        ["Birne", "Ananas"].forEach((f) => addValue(f, 1.0));
        ["Zucchetti"].forEach((f) => addValue(f, 0.5));
      } else if (formValues.everythingisdone === "Nein") {
        ["Apfel", "Rüebli", "Zucchetti", "Tomate"].forEach((f) =>
          addValue(f, 1.0)
        );
      }
    }

    // Eating patterns
    if (isValid(formValues.eveninginpeace)) {
      if (formValues.eveninginpeace === "ja") {
        ["Apfel"].forEach((f) => addValue(f, 1.0));
        ["Zucchetti"].forEach((f) => addValue(f, 0.5));
      } else if (formValues.eveninginpeace === "Nein") {
        ["Tomate", "Birne", "Ananas", "Zucchetti"].forEach((f) =>
          addValue(f, 1.0)
        );
      }
    }

    return newFruits;
  };

  const handleKeyDown = (e) => {
    // Check if the target is a textarea and Enter key is pressed
    if (e.key === "Enter") {
      if (e.target.tagName === "TEXTAREA") {
        if (e.shiftKey) {
          // If Shift + Enter is pressed, allow the default behavior (inserting a new line)
          return;
        } else {
          // Prevent default behavior (adding a new line)
          e.preventDefault();

          // Proceed to the next step or submit based on the current step
          if (currentStep < formSteps.length - 1) {
            handleNext();
          } else {
            handleSubmit(); // Trigger submission on the last step
          }
        }
      } else {
        // If it's not a textarea, simply proceed to the next step
        if (currentStep < formSteps.length - 1) {
          handleNext();
        } else {
          handleSubmit(); // Trigger submission on the last step
        }
      }
    }
  };

  const normalizeSliderWeeks = (value, fallback = 10) => {
    const parsed = parseInt(value, 10);
    return parsed >= 1 && parsed <= 52 ? parsed : fallback;
  };

  const handleSubmit = async () => {
    console.log(formValues);
    localStorage.removeItem("formValues");
    localStorage.removeItem("currentStep");
    const submissionValues = {
      ...formValues,
      sliderValues: normalizeSliderWeeks(formValues.sliderValues),
    };
    const formValuesArray = Object.values(submissionValues);

    const combinedObject = Object.entries(submissionValues).reduce(
      (acc, [key, value], index) => {
        acc[key] = {
          Question: formSteps[index] || "",
          Answer: value || "",
        };
        return acc;
      },
      {}
    );

    setIsLoading(true); // Start loading
    setCountdown(120); // Reset countdown
    timerRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(timerRef.current);
        }
        return prev - 1;
      });
    }, 1000);

    // sliderValues
    console.log(combinedObject);
    if (combinedObject && combinedObject["sliderValues"]) {
      combinedObject["sliderValues"].Question =
        "Geplante Wochen zur Erreichung des Zielgewichts";
    }

    if (combinedObject && combinedObject["bmi"]) {
      combinedObject["bmi"].Question = "Wie hoch ist Ihr aktueller BMI?";
    }
    if (combinedObject && combinedObject["bmiTarget"]) {
      combinedObject["bmiTarget"].Question =
        "Wie hoch ist Ihr angestrebter BMI?";
    }
    if (combinedObject && combinedObject["gender"]) {
      combinedObject["gender"].Question = "Geschlecht";
    }

    // Combine all images into one object
    combinedObject.uploadphotos = {
      Question: "Hochgeladene Fotos",
      Answer: {
        uploadphotosFront: formValues.uploadphotosFront || "",
        uploadphotosBack: formValues.uploadphotosBack || "",
        uploadphotosSide: formValues.uploadphotosSide || "",
        uploadphotosStomach: formValues.uploadphotosStomach || "",
        uploadphotosThighs: formValues.uploadphotosThighs || "",
      }
    };

    // Remove the individual image fields from the payload
    delete combinedObject.uploadphotosFront;
    delete combinedObject.uploadphotosBack;
    delete combinedObject.uploadphotosSide;
    delete combinedObject.uploadphotosStomach;
    delete combinedObject.uploadphotosThighs;

    combinedObject.bodyType = {
      Question: "Ihr Körpertyp ist",
      Answer: "",
    };
    combinedObject.fruitPoints = {
      Question: "Nährwertangaben Fruchtpunkte",
      Answer: {},
    };

    const updatedFruits = calculateFruitValues(formValues);
    setCurrentFruitValues(updatedFruits);
    const newFruits = currentFruitValues;

    // Ensure newFruits is an object with fruit names as keys and values as their counts
    const fruitCount = Object.entries(newFruits).map(([fruit, count]) => {
      const fruitData = formValues.bmifruits?.find(
        (item) => item.name === fruit
      );
      const value = fruitData ? fruitData.value : 0;
      const combinedValue = count + value;
      return { fruit, value: combinedValue };
    });

    // Find the top fruit with the highest combined value
    let topFruit = null;
    if (fruitCount.length > 0) {
      topFruit = fruitCount.reduce((max, current) =>
        current.value > max.value ? current : max
      );
    }

    let resultValu;
    if (topFruit) {
      resultValu = {
        height: topFruit.value,
        fruitName: topFruit.fruit,
      };
    } else {
      resultValu = "";
    }

    // Update combinedObject with the top fruit's name in bodyType
    if (combinedObject && combinedObject["bodyType"]) {
      combinedObject["bodyType"].Answer = resultValu && resultValu.fruitName ? resultValu.fruitName : "";
    }

    if (combinedObject && combinedObject["fruitPoints"]) {
      combinedObject["fruitPoints"].Answer = fruitCount;
    }

    setFormValues((prevValues) => ({
      ...prevValues,
      result: fruitCount,
    }));

    var formValuesStr = JSON.stringify(combinedObject);
    var date_of_date = formValues.dateOfBirth;
    const dateObj = new Date(date_of_date);
    var date_part = dateObj.toISOString().split("T")[0];

    try {
      // Schritt 1: Report speichern
      const response = await fetch(
        "https://iwucuziw.myhostpoint.ch/api/report/store",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formValues.name,
            email: formValues.Email,
            date_of_birth: date_part,
            payload: formValuesStr,
          }),
        }
      );

      if (response.ok) {
        clearInterval(timerRef.current);
        const data = await response.json();
        console.log("Report saved successfully:", data);

        // Zeige Success Message sofort
        setSubmissionSuccess(true);
        setShowFinalMessage(true);
        setIsLoading(false);

        // Schritt 2: AI-Generierung im Hintergrund starten (ohne UI-Feedback)
        if (data.report_id) {
          startAiGenerationInBackground(data.report_id, combinedObject);
        }
      } else {
        clearInterval(timerRef.current);
        console.error("Error:", response.statusText);
        alert("Fehler beim Senden des Berichts.");
        setIsLoading(false);
      }
    } catch (error) {
      clearInterval(timerRef.current);
      console.error("Error:", error);
      alert("Beim Senden des Berichts ist ein Fehler aufgetreten.");
      setIsLoading(false);
    }
  };

  // Neue Funktion für AI-Generierung im Hintergrund
  const startAiGenerationInBackground = async (reportId, combinedObject) => {
    try {
      console.log("Starting AI generation for report ID:", reportId);
      console.log("BodyType in combinedObject:", combinedObject?.bodyType);

      // Validate that bodyType has an Answer before sending
      if (!combinedObject?.bodyType?.Answer) {
        console.error("ERROR: bodyType.Answer is missing or empty!", {
          bodyType: combinedObject?.bodyType,
          hasBodyType: !!combinedObject?.bodyType,
          hasAnswer: !!combinedObject?.bodyType?.Answer
        });
        return;
      }

      // Starte AI-Generierung ohne UI-Feedback
      const response = await fetch(
        `https://iwucuziw.myhostpoint.ch/api/report/generate-ai/${reportId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            formatted_report: combinedObject,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        console.log("AI generation started successfully", data);
      } else {
        const errorData = await response.json().catch(() => ({ message: response.statusText }));
        console.error("Failed to start AI generation:", {
          status: response.status,
          statusText: response.statusText,
          error: errorData
        });
      }
    } catch (error) {
      console.error("Error starting AI generation:", error);
    }
  };

  const handleNext = () => {
    if (isStepValid()) {
      setShowWarning(false);
      if (currentStep < formSteps.length - 1) {
        setCurrentStep((prevStep) => {
          const newStep = prevStep + 1;
          localStorage.setItem("currentStep", newStep); // Save current step
          return newStep;
        });
      }
    } else {
      setShowWarning(true);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep((prevStep) => {
        const newStep = prevStep - 1;
        localStorage.setItem("currentStep", newStep); // Save current step
        return newStep;
      });
    }
  };

  useEffect(() => {
    const savedValues = localStorage.getItem("formValues");
    const savedStep = localStorage.getItem("currentStep");

    if (savedValues) {
      const parsed = JSON.parse(savedValues);
      parsed.sliderValues = normalizeSliderWeeks(parsed.sliderValues);
      setFormValues(parsed);
    }
    if (savedStep) {
      setCurrentStep(parseInt(savedStep));
    }
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    const excludeKeys = [
      "uploadphotos",
      "uploadphotosFront",
      "uploadphotosBack",
      "uploadphotosSide",
      "uploadphotosStomach",
      "uploadphotosThighs",
    ];

    setFormValues((prevValues) => {
      if (prevValues[name] !== value) {
        const newValues = {
          ...prevValues,
          [name]: value,
        };

        // Save to localStorage without excluded keys
        const valuesToStore = Object.fromEntries(
          Object.entries(newValues).filter(
            ([key]) => !excludeKeys.includes(key)
          )
        );
        localStorage.setItem("formValues", JSON.stringify(valuesToStore));

        // 👇 Call calculateFruitValues with newValues (not old formValues)
        const updatedFruits = calculateFruitValues(newValues);
        setCurrentFruitValues(updatedFruits);

        console.log("Updated Fruits:", updatedFruits);
        console.log("Updated Values ", newValues);
        return newValues;
      }

      return prevValues;
    });
  };

  const handleSliderChange = (e, newValue) => {
    setFormValues({ ...formValues, targetWeight: newValue });
    setShowWarning(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getFieldName = (step) => {
    // setShowStep(step)
    switch (step) {
      case 0:
        seinhowStep = step;
        return "name";
      case 1:
        seinhowStep = step;
        return "dateOfBirth";
      case 2:
        seinhowStep = step;
        return "Email";
      case 3:
        seinhowStep = step;
        return "bodyhight";
      case 4:
        seinhowStep = step;
        return "currentbody";
      case 5:
        seinhowStep = step;
        return "targetWeight"; // Updated to match formValues key
      case 6:
        seinhowStep = step;
        return "about";
      case 7:
        seinhowStep = step;
        return "mygoals";
      case 8:
        seinhowStep = step;
        return "physicalproblem";
      case 9:
        seinhowStep = step;
        return "bodylooked";
      case 10:
        seinhowStep = step;
        return "eatingdisorder";
      case 11:
        seinhowStep = step;
        return "myperseverance";
      case 12:
        seinhowStep = step;
        return "tissuelegs";
      case 13:
        seinhowStep = step;
        return "dietwithtimestamp";
      case 14:
        seinhowStep = step;
        return "labelmydiet";
      case 15:
        seinhowStep = step;
        return "youdrink";
      case 16:
        seinhowStep = step;
        return "craving";
      case 17:
        seinhowStep = step;
        return "glassesalcohol";
      case 18:
        seinhowStep = step;
        return "myallergies";
        // case 19:
        seinhowStep = step;
      //   return "orderperweek";
      case 19:
        seinhowStep = step;
        return "eatingperweek";
      case 20:
        seinhowStep = step;
        return "attentionyourdiet";
      case 21:
        seinhowStep = step;
        return "trainperweek";
      case 22:
        seinhowStep = step;
        return "traintotal";
      case 23:
        seinhowStep = step;
        return "stepseveryday";
      case 24:
        seinhowStep = step;
        return "averageperday";
      case 25:
        seinhowStep = step;
        return "Schritte";
      case 26:
        seinhowStep = step;
        return "MeTime";
      case 27:
        seinhowStep = step;
        return "proTag";
      case 28:
        seinhowStep = step;
        return "beiStress";
      case 29:
        seinhowStep = step;
        return "zufrieden";
      case 30:
        seinhowStep = step;
        return "wieverteilt";
      case 31:
        seinhowStep = step;
        return "verteilt";
      case 32:
        seinhowStep = step;
        return "Schlafdauer";
      case 33:
        seinhowStep = step;
        return "Schlafqualität";
      case 34:
        seinhowStep = step;
        return "energielos";
      case 35:
        seinhowStep = step;
        return "Verdauung";
      case 36:
        seinhowStep = step;
        return "Regeneration";
      case 37:
        seinhowStep = step;
        return "stehst";
      case 38:
        seinhowStep = step;
        return "Erkrankungen";
      case 39:
        seinhowStep = step;
        return "heartrate";
      case 40:
        seinhowStep = step;
        return "eatmore";
      case 41:
        seinhowStep = step;
        return "feelalive";
      case 42:
        seinhowStep = step;
        return "stressful";
      case 43:
        seinhowStep = step;
        return "everythingisdone";
      case 44:
        seinhowStep = step;
        return "eveninginpeace";
      case 45:
        seinhowStep = step;
        return "uploadphotos";
      // case 46:
      //   seinhowStep = step;
      //   return "finalevalution";
      case 47:
        seinhowStep = step;
        return "Zyklus";

      default:
        seinhowStep = 0;
        return "";
    }
  };

  const getOptions = (step) => {
    switch (step) {
      case 8:
        return [
          // { value: '1', label: 'Select an option' },
          { value: "Bauch", label: "Bauch" },
          { value: "Arme", label: "Arme" },
          { value: "Bauch und Arme", label: "Bauch und Arme" },
          {
            value: "Oberschenkel / Po und Bauch",
            label: "Oberschenkel / Po und Bauch",
          },
          {
            value: "Oberschenkel / Po und Arme",
            label: "Oberschenkel / Po und Arme",
          },
          { value: "Oberschenkel / Po", label: "Oberschenkel / Po" },
          { value: "Ganzer Körper", label: "Ganzer Körper" },
        ];
      case 9:
        return [
          // { value: '2', label: 'Select an option' },
          { value: "Dünn / drahtig", label: "Dünn / drahtig" },
          {
            value: "Athletisch / sichtbare Muskulatur",
            label: "Athletisch / sichtbare Muskulatur",
          },
          {
            value: "Massiger als der Durchschnitt",
            label: "Massiger als der Durchschnitt",
          },
        ];
      case 10:
        return [
          // { value: '3', label: 'Select an option' },
          { value: "Nein", label: "Nein" },
          { value: "Ja, Magersucht ", label: "Ja, Magersucht " },
          { value: "Ja, Bulimie", label: "Ja, Bulimie" },
          { value: "Ja, Binge eating", label: "Ja, Binge eating" },
        ];
      // case 11:
      //   return [
      //     { value: '', label: 'Select an option' },
      //     { value: '<6', label: '<6' },
      //     { value: '>=6', label: '>=6' },
      //   ];
      case 12:
        return [
          // { value: '4', label: 'Select an option' },
          {
            value: "schwammig als wäre Wasser drin",
            label: "Schwammig als wäre Wasser drin",
          },
          { value: "Cellulite", label: "Cellulite" },
          {
            value: "beim kneiffen tut mir mein Gewebe weh",
            label: "Beim kneiffen tut mir mein Gewebe weh",
          },
          { value: "unauffällig", label: "Unauffällig" },
        ];

      case 14:
        return [
          // { value: '5', label: 'Select an option' },
          {
            value: "No specific dietary form",
            label: "Keine spezifische Ernährungsform",
          },
          { value: "Vegan ", label: "Vegan " },
          { value: "vegetarisch ", label: "Vegetarisch" },
          { value: "Low carb ", label: "Low carb " },
          { value: "intervallfasten", label: "Intervallfasten" },
          { value: "High Protein ", label: "High Protein " },
          { value: "ausgewogen ", label: "Ausgewogen " },
        ];
      case 17:
        return [
          // { value: '6', label: 'Select an option' },
          {
            value: "Ich trinke kein Alkohol",
            label: "Ich trinke kein Alkohol",
          },
          { value: "1-2 Gläser", label: "1-2 Gläser" },
          { value: "3-4 Gläser", label: "3-4 Gläser" },
          { value: "5 und mehr Gläser", label: "5 und mehr Gläser" },
        ];
      // case 22:
      //   return [
      //     // { value: '7', label: 'Select an option' },
      //     { value: 'Körpertypen <300 min pro Woche ', label: 'Körpertypen <300 min pro Woche ' },
      //     { value: 'Kopflastige Körpertypen >300 min pro Woche ', label: 'Kopflastige Körpertypen >300 min pro Woche ' },
      //   ];
      case 23:
        return [
          // { value: '8', label: 'Select an option' },
          { value: "ja", label: "Ja" },
          { value: "Nein", label: "Nein" },
        ];
      // case 24:
      //   return [
      //     // { value: '9', label: 'Select an option' },
      //     { value: 'Anzahl Schritte ', label: 'Anzahl Schritte ' },
      //     { value: 'Pal Wert', label: 'Pal Wert' },
      //   ];
      // case 39:
      //   return [
      //     // { value: '10', label: 'Select an option' },
      //     { value: '>80', label: '>80' },
      //     { value: '<60', label: '<60' },

      //   ];
      case 40:
        return [
          // { value: '11', label: 'Select an option' },
          { value: "ja", label: "Ja" },
          { value: "Nein ich esse weniger", label: "Nein ich esse weniger" },
          {
            value: "Nein ich esse wie sonst auch",
            label: "Nein ich esse wie sonst auch",
          },
        ];
      case 41:
        return [
          // { value: '12', label: 'Select an option' },
          { value: "ja", label: "Ja" },
          { value: "Nein", label: "Nein" },
        ];
      case 42:
        return [
          // { value: '13', label: 'Select an option' },
          { value: "ja", label: "Ja" },
          { value: "Nein", label: "Nein" },
        ];
      case 43:
        return [
          // { value: '14', label: 'Select an option' },
          { value: "ja", label: "Ja" },
          { value: "Nein", label: "Nein" },
        ];
      case 44:
        return [
          // { value: '15', label: 'Select an option' },
          { value: "ja", label: "Ja" },
          { value: "Nein", label: "Nein" },
        ];
      // case 46:
      //   return [
      //     // { value: '16', label: 'Select an option' },
      //     { value: 'Karotte: Seide', label: 'Karotte: Seide' },
      //     { value: 'Apfel: Wolle ', label: 'Apfel: Wolle ' },
      //     { value: 'Avocado: Kork ', label: 'Avocado: Kork ' },
      //     { value: 'Zucchetti: Holz ', label: 'Zucchetti: Holz ' },
      //     { value: 'Ananas: Leder ', label: 'Ananas: Leder ' },
      //     { value: 'Birne: Lehm  ', label: 'Birne: Lehm  ' },
      //     { value: 'Tomate: Stein  ', label: 'Tomate: Stein  ' },
      //     { value: 'Mais: Metall ', label: 'Mais: Metall ' },
      //   ];
      default:
        return null;
    }
  };

  const progressPercentage = (currentStep / (formSteps.length - 1)) * 100;

  const setSelectedDate = (data) => {
    setFormValues({ ...formValues, dateOfBirth: data });
    setShowWarning(false);
  };

  const setFruitesValueFun = (data) => {
    console.log(data);
    setFruitesValueFu(data);
  };

  return (
    <div>
      {/* /* <button onClick={() => { handleSubmit() }}>handleSubmit</button> */}
      <div className="form-under-box" onKeyDown={handleKeyDown} tabIndex="0">
        <section>
          <div className="lady-main">
            <div className="lady-img">
              <div className="ladyy" style={{ width: "100%" }}>
                <img src={lady} alt="lady" className="fruit-img" />
              </div>
              {/* <div className='animate__animated animate__fadeInLeft' style={{ position:'absolute',left:'20%',top: '65%' }}>
                <p style={{color:'#fff',backgroundColor:'#ff4000', padding:'2px 5px 2px 20px',borderRadius:'70px 10px 0px 0px',fontSize:'14px' }} >
                  Create healthy habits, not restrictions
                </p>
                <p className='animate__animated animate__fadeInLeft' style={{color:'#fff',backgroundColor:'#ff4000', padding:'2px 5px 2px 20px',borderRadius:'70px 10px 0px 0px',fontSize:'14px' }}>
                  Take care of your body. It’s the only place you have to live
                </p>
                <p className='animate__animated animate__fadeInLeft' style={{color:'#fff',backgroundColor:'#ff4000', padding:'2px 5px 2px 20px',borderRadius:'70px 10px 0px 0px',fontSize:'14px' }}>
                  Healthy is an outfit that looks different on everybody.
                </p>
              </div> */}
            </div>

            {/* <div> <img src={f2} alt="f2" className='fruit-img' /></div> */}
            {/* <div> <img src={f3} alt="f3" className='fruit-img' /></div> */}
            {/* <div> <img src={f3} alt="f5" className='fruit-img' /></div> */}
            {/* <div> <img src={f1} alt="f1" className='fruit-img' /></div> */}
          </div>
          <div className="leaf leaf1">
            {/* <div> <img src={f4} alt="f4" className='fruit-img' /></div> */}
            {/* <div> <img src={f5} alt="f5" className='fruit-img' /></div> */}
            {/* <div> <img src={f6} alt="f" className='fruit-img' /></div> */}
            {/* <div> <img src={f6} alt="f6" className='fruit-img' /></div> */}
            <div>
              {" "}
              <img src={rotate} alt="rotate" className="fruit-img-rotate" />
            </div>
          </div>
          <div className="leaf leaf2"></div>
        </section>

        <div className="form-main-div  ">
          {vissibleAll ? (
            <>
              <Form
                setFruitesValue={setFruitesValueFun}
                label={formSteps[currentStep]}
                comments={formSteps[currentStep]}
                name={getFieldName(currentStep)}
                value={formValues[getFieldName(currentStep)]}
                formValues={formValues} // Pass formValues as a prop
                setFormValues={setFormValues} // Pass setFormValues as a prop
                onChange={handleInputChange}
                onSliderChange={handleSliderChange}
                handleKeyDown={handleKeyDown}
                options={getOptions(currentStep)}
                helperText={
                  currentStep === 45
                    ? "Füge die Bilder hinzu, indem du auf die jeweilige Abbildung klickst"
                    : ""
                  // currentStep === 3 ? "zb 160cm" :
                  // currentStep === 4 ? "zb 65kg" :
                  // currentStep === 5 ? "Reiter muss unrealistisches Gewichtsziel angeben" :
                  // currentStep === 13 ? "zb. 9:00 Müesli aus 250g Magerquark,1 Handvoll Beeren und 50g Haferflocken" :
                  // currentStep === 19 ? "'zb2x'" :
                  // currentStep === 20 ? "'zb2x'" :

                  // currentStep === 26 ? "'zb 10 Min'" :
                  // currentStep === 35 ? " 'zb Massage, Blackroll, schröpfen etc'" :
                }
                disclaimerText={
                  currentStep === 45
                    ? "Diese Fotos werden ausschliesslich für die Zwecke dieser Analyse verwendet."
                    : ""
                }
                setSelectedDate={setSelectedDate}
              />
              {showWarning && (
                <div className="warning-message">
                  {/* Wert erforderlich */}
                  {seinhowStep == 45 ? (
                    <>
                      <p>
                        Frontansicht (Foto von vorne) <br />
                        Rückansicht (Foto von hinten)
                        <br />
                        Seitenansicht (Foto von der Seite)
                        <br />
                        Bauchansicht (Foto vom Bauch)
                        <br />
                        Oberschenkelansicht (Foto von den Oberschenkeln)
                      </p>
                    </>
                  ) : currentStep === 5 &&
                    formValues.targetWeightValidationError &&
                    String(formValues.targetWeightValidationError).trim() !==
                    "" ? (
                    <p style={{ whiteSpace: "pre-line" }}>
                      {formValues.targetWeightValidationError}
                    </p>
                  ) : (
                    "Wert erforderlich"
                  )}
                </div>
              )}
              <div className="form-button-main">
                {currentStep > 0 && (
                  <button className="back-button" onClick={handleBack}>
                    <ArrowBackIcon /> Zurück
                  </button>
                )}
                {currentStep < formSteps.length - 1 ? (
                  <button
                    className="next-button"
                    type="button"
                    onClick={handleNext}
                    disabled={
                      currentStep === 5 &&
                      formValues.warningMessage &&
                      formValues.warningMessage.includes(
                        "Kann zu ernsthaften gesundheitlichen Problemen führen!"
                      )
                    }
                  >
                    Nächste <ArrowForwardIcon />
                  </button>
                ) : (
                  <button
                    className="submit-button"
                    onClick={() => {
                      // setVissibleAll(false)
                      if (isStepValid()) {
                        setShowWarning(false);
                        setVissibleAll(false);
                        handleSubmit();
                      } else {
                        setShowWarning(true);
                      }
                    }}
                    type="submit"
                  >
                    Einreichen <DoneOutlineIcon />
                  </button>
                )}
              </div>
              <LinearProgress
                variant="determinate"
                value={progressPercentage}
                className="progress-bar"
              />
              <div className="page-number">
                {" "}
                Seite <span>{currentStep + 1}</span> von{" "}
                <span>{formSteps.length}</span>
              </div>{" "}
              {/* Page numbering */}
              <div>
                <p
                  className=""
                  style={{
                    margin: "auto",
                    color: "#212529",
                    fontSize: "14px",
                    fontFamily: "CustomFont",
                    fontWeight: "bold",
                    padding: "80px 0px 0px 0px",
                  }}
                >
                  <strong style={{ color: "#000" }}>Zur Info: </strong>
                  Deine Eingaben werden im Browser gespeichert, solange du die
                  Cookies nicht löschst.
                  <br />
                  Du kannst das Formular jederzeit wieder öffnen und fortsetzen.
                </p>
              </div>
            </>
          ) : (
            <>
              {/* <h2
                style={{
                  fontSize: "20px",
                  textAlign: "center",
                  fontWeight: "bold",
                  marginTop: "50px",
                  marginBottom: "50px",
                  fontFamily: "CustomFont",
                  lineHeight: "1.5,",
                }}
              >
                Danke, dass du dir die Zeit für unsere Körpertyp-Analyse
                genommen hast! Wir werten deine Antworten jetzt aus und melden
                uns in der Regel innerhalb von 2-3 Arbeitstagen mit den
                Ergebnissen bei
                 dir. Bis bald!
              </h2> */}
              {isLoading && (
                <h2
                  style={{
                    fontSize: "25px",
                    textAlign: "center",
                    fontWeight: "bold",
                    marginTop: "50px",
                    marginBottom: "50px",
                    fontFamily: "CustomFont",
                    lineHeight: "1.5",
                  }}
                >
                  Deine Analyse wird verarbeitet... Bitte warte
                  <strong style={{ color: "#ff4000" }}>
                    {" "}
                    {countdown} Sekunden
                  </strong>{" "}
                  und schliesse das Fenster erst danach. Danke für deine Geduld!
                </h2>
              )}

              {showFinalMessage && (
                <h2
                  style={{
                    fontSize: "20px",
                    textAlign: "center",
                    fontWeight: "bold",
                    marginTop: "50px",
                    marginBottom: "50px",
                    fontFamily: "CustomFont",
                    lineHeight: "1.5",
                  }}
                >
                  Danke, dass du dir die Zeit für unsere Körpertyp-Analyse
                  genommen hast! Wir werten deine Antworten jetzt aus und melden
                  uns in der Regel innerhalb von 2-3 Arbeitstagen mit den
                  Ergebnissen bei dir. Bis bald!
                </h2>
              )}
            </>
          )}
        </div>

        {(currentStep !== 46 || !isMobile) && (
          <>
            <div className="nav-logo">
              <h1 className="typography-display1  animate__animated animate__fadeInLeft ">
                Körpertyp Analyse
              </h1>

              <img
                className="animate__animated animate__fadeInRight"
                src={logo}
                alt="Weight Arrow"
              />
            </div>
          </>
        )}

        {/* <section>
          <div> <img src={rotate} alt="rotate" className='fruit-img' /></div>
        </section> */}
      </div>
    </div>
  );
}

export default App;
